import { useFileUploadItemContext } from './useFileUploadItemContext'

export function useFileUploadItemProgressState() {
    const { fileState } = useFileUploadItemContext()

    const progress = fileState?.progress ?? 0
    const showProgress = progress !== 100

    return {
        progress,
        showProgress,
    }
}
